/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstantsService } from './api-constants.service';
import { Company, CompanyListParams } from '~core/models/company.models';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class CompanyService {
  protected _httpClient = inject(HttpClient);
  protected _apiConstantsService = inject(ApiConstantsService);

  read(companyId: string): Observable<Company> {
    return this._httpClient.get<Company>(
      `${this._apiConstantsService.companyUrl}/${companyId}`
    );
  }

  list(params?: CompanyListParams): Observable<Pagination<Company>> {
    return this._httpClient.get<Pagination<Company>>(
      this._apiConstantsService.companyUrl,
      {
        params: {
          ...params,
          details: '',
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }
}
